





























import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import Upload from './upload.vue'
import {SaveMedDoc} from "@/api/hd"
import {GetListByCode} from "@/api/configureDictionary"

@Component({
	components: {Upload}
})
export default class MedDocs extends AbpBase {
	@Prop() value: boolean
	@Prop() data: any
	form: any = {
		inputDate: "",
		medDocType: ""
	}
	piclist: any = {
		list: []
	}
	medDocTypes:any = []
	pics: any = []

	created() {
		this.getSelects()
		if (this.data.mode === 'add') {
			this.form = {
				inputDate: new Date()
			}
		} else {
			let data = this.data.data.photoAddress.split(";")
			let pics:any = []
			data.forEach((item:any) => {
				let ps = item.split("/")
				pics.push({
					name: ps[ps.length-1],
					imgUrl: item,
				})
			})
			this.piclist.list = pics
			this.form = {
				inputDate: this.data.data.inputDate,
				medDocType: this.data.data.medDocType
			}
		}
	}

	async getSelects() {
		let res = await GetListByCode({input: '030'})
		this.medDocTypes = res
		if (this.data.mode === "add") {
			this.form.medDocType = res[0].id
		}
	}

	picChange(val: any) {
		this.pics = val
	}

	async save() {
		if (!this.pics.length) {
			this.$Message.error("还没有上传图片!")
			return
		}
		let data:any = {
			patientId: this.data.patient.id,
			inputDate: this.formatDate(this.form.inputDate),
			medDocType: this.form.medDocType,
			photoAddress: ""
		}
		if (this.data.mode !== "add") {
			data.id = this.data.data.id
		}
		let urls:string[] = []
		this.pics.forEach((item:any) =>{
			urls.push(item.url)
		})
		data.photoAddress = urls.join(";")
		let res = await SaveMedDoc(data)
		if (res.status === 1) {
			this.$emit("save-success")
		}
	}

	cancel() {
		this.$emit('close');
	}

	get modalTitle() {
		return (this.data.mode === 'add' ? '新增' : '编辑') + '医疗文书'
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('close');
		}
	}

	rules = {
		inputDate: [{required: true, message: this.L('FieldIsRequired'), }],
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/medDocs/parts/addOrEdit.vue